import { Autocomplete, TextField } from "@mui/material";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import {
  Button,
  Col,
  Container,
  Form,
  Input,
  Label,
  Modal,
  ModalBody,
  Row,
  Spinner,
} from "reactstrap";
import { requestForNewSchool } from "store/actions/requestForNewSchoolAction";
import firebase from "../config/firebase";
const InstituteRegistrationModal = ({ isOpen, toggle }) => {
  let dispatch = useDispatch();
  let [btnLoader, setBtnLoader] = useState(false);
  const [formData, setFormData] = useState({
    instituteLevel: "College",
    state: "",
    city: "",
    institute: "",
    email: "",
  });
  const handleChange = (e) => {
    let { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    if (name == "instituteLevel") {
      setFormData({
        instituteLevel: value,
        state: "",
        city: "",
        institute: "",
        email: "",
      });
    }
  };

  const defaultStateProps = {
    options: [
      "Alabama",
      "Alaska",
      "Arizona",
      "Arkansas",
      "California",
      "Colorado",
      "Connecticut",
      "Delaware",
      "Florida",
      "Georgia",
      "Hawaii",
      "Idaho",
      "Illinois",
      "Indiana",
      "Iowa",
      "Kansas",
      "Kentucky",
      "Louisiana",
      "Maine",
      "Maryland",
      "Massachusetts",
      "Michigan",
      "Minnesota",
      "Mississippi",
      "Missouri",
      "Montana",
      "Nebraska",
      "Nevada",
      "New Hampshire",
      "New Jersey",
      "New Mexico",
      "New York",
      "North Carolina",
      "North Dakota",
      "Ohio",
      "Oklahoma",
      "Oregon",
      "Pennsylvania",
      "Rhode Island",
      "South Carolina",
      "South Dakota",
      "Tennessee",
      "Texas",
      "Utah",
      "Vermont",
      "Virginia",
      "Washington",
      "West Virginia",
      "Wisconsin",
      "Wyoming",
    ],
    getOptionLabel: (option) => option,
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setBtnLoader(true);
    let data = {
      ...formData,
      createdAt: firebase.firestore.FieldValue.serverTimestamp(),
    };
    dispatch(
      requestForNewSchool(data, () => {
        setBtnLoader(false);
        toggle();
        setFormData({
          instituteLevel: "College",
          state: "",
          city: "",
          institute: "",
          email: "",
        });
      })
    );
  };
  return (
    <Modal isOpen={isOpen} toggle={toggle} size="lg">
      <ModalBody>
        <Container>
          <h2>Email needed for quick approval notification.</h2>
          <Form onSubmit={handleSubmit} className=" mt-5">
            <Label className="mt-3 auth-label">
              Click for College or High School
            </Label>
            <div className="d-flex ml-4  mt-2 mb-4">
              <div>
                <Input
                  type="radio"
                  checked={formData.instituteLevel == "College"}
                  id="d_yes"
                  name="instituteLevel"
                  value="College"
                  onChange={handleChange}
                />
                <Label
                  for="d_yes"
                  className={`auth-label ${
                    formData.instituteLevel == "College" ? "text-primary" : ""
                  }`}
                >
                  College
                </Label>
              </div>
              <div className="mx-auto">
                <Input
                  type="radio"
                  id="d_no"
                  name="instituteLevel"
                  checked={formData.instituteLevel == "High School"}
                  value="High School"
                  onChange={handleChange}
                />
                <Label
                  for="d_no"
                  className={`auth-label ${
                    formData.instituteLevel == "High School"
                      ? "text-primary"
                      : ""
                  }`}
                >
                  High School
                </Label>
              </div>
            </div>

            <Label className="mt-2 auth-label">
              Address Where
              {formData.instituteLevel == "College"
                ? " College"
                : " School"}{" "}
              Located
            </Label>
            <br />
            <Row>
              <Col md="6">
                <Label className="auth-label mt-3">State</Label>
                <Autocomplete
                  {...defaultStateProps}
                  id="auto-complete"
                  name="state"
                  autoComplete
                  includeInputInList
                  value={formData.state}
                  onChange={(e, val) => {
                    setFormData((prev) => ({
                      ...prev,
                      state: val,
                    }));
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      placeholder="State"
                      variant="standard"
                    />
                  )}
                />
              </Col>
              <Col md="6">
                <Label className="auth-label ">
                  {formData.instituteLevel == "College" ? "City" : "County"}
                </Label>
                <Input
                  required
                  placeholder="Add City"
                  type="text"
                  className="custom-input"
                  name="city"
                  value={formData.city}
                  onChange={handleChange}
                />
              </Col>
              <Col md="6">
                <Label className="auth-label ">School</Label>
                <Input
                  required
                  placeholder="Add School Name"
                  type="text"
                  className="custom-input"
                  name="institute"
                  value={formData.institute}
                  onChange={handleChange}
                />
              </Col>
              <Col md="6">
                <Label className="auth-label">Email</Label>
                <Input
                  required
                  placeholder="name@gmail.com"
                  type="email"
                  className="custom-input"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                />
              </Col>
            </Row>
            <div className="text-right mt-5">
              <Button color="danger" onClick={toggle}>
                Close
              </Button>
              <Button
                type="submit"
                color="primary"
                disabled={!formData.state || btnLoader}
              >
                {btnLoader ? <Spinner size="sm" /> : "Submit"}
              </Button>
            </div>
          </Form>
        </Container>
      </ModalBody>
    </Modal>
  );
};

export default InstituteRegistrationModal;
